<template>
  <div class="personal-center row flex-center">
    <img :src="self.avatar || avatarDef" class="user-head mr8" />
    <div class="flex-1">
      <!-- <div class="row flex-center">
        <span class="font-666">微信昵称：</span>
        <span class="mr8">{{ self.name }}</span>
        <span>{{ self.remarkMobiles }}</span>
      </div> -->
      <div class="row flex-center mt4">
        <div class="font-666">绑定患者：</div>
        <div class="fs12" v-if="!self.patientId || self.patientId == ''">
          未绑定蓝莓象（his）患者
        </div>
        <div v-else>
          <span class="mr8">{{ self.patientName }}</span>
          <span class="mr8">{{ self.genderText }}</span>
          <span v-if="self.age">{{ self.age }}岁</span>
        </div>
      </div>
      <div class="row flex-center mt4 group-info">
        <div class="flex-center flex-1">
          <span class="font-666">添加员工：{{ self.addNum  }}人</span>
          <span class="ml20 font-666">添加群聊：{{ self.groupChatNum  }}个</span>
        </div>
      
        <div class="add-group-btn" v-if="self.externalUserId && self.patientId && self.groupChatNum==0" @click="quickCreateGroup">
          拉群
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import avatarDef from "@/assets/img/avatar/avatardef.png";
import { useRouter } from "vue-router";
import { userStore } from "@/store/user.js";

export default {
  name: "userInfo",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  components: {},
  data: function () {
    return {
      avatarDef,
    };
  },
  setup() {
    const router = useRouter();
    return {
      router,
    };
  },

  mounted: function () {
    
  },
  methods: {
    quickCreateGroup() {
      let user = userStore();
      let cusId = user.cusId;

      this.router.push({
        name: "createGroupStep1",
        query: {
          patientId: this.self.patientId,
          externalUserId: cusId,
        },
      });
      
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-center {
  color: #333;
  background-color: #fff;
  padding: 0.083rem 0.25rem;
  border-top: 2px solid #f7f7f7;
  border-bottom: 2px solid #f7f7f7;
}

.user-head {
  display: block;
  width: 0.833rem;
  height: 0.833rem;
  border-radius: 50%;
  overflow: hidden;
}

.group-info {
  text-align: left;
  .add-group-btn{
    background-color: #28B8C3;
    color: #fff;
    padding: 2px 8px;
    border-radius:999px;
    cursor: pointer;
    font-size: .25rem;
  
  }
}
</style>
